var modal = require('../modal-static')
var photoPanel

function setUpBrowserBackButton(){
    photoPanel = document.getElementById('photo-panel');
    // now check we have an overlay
    if(photoPanel){
        // set history to current url
        history.pushState(null, null, document.URL);
        // popstate event is fired should the browser history change
        window.addEventListener('popstate', function () {
            // set history to current url
            history.pushState(null, null, document.URL);
            // close modal
            modal.destroy()
        });
    }
}

module.exports.setUpBrowserBackButton = setUpBrowserBackButton;